import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import PropTypes from 'prop-types';
import { metaOverrideSet } from '../InsightSection/metaOverrideSet';
import InsightSection from '../InsightSection';

const InsightForm = ({ onSubmit }) => {
  const { resource } = useMetaLayoutContext();

  return (
    <MetaCollectionFormInline
      collection={resource?.attr('facetPlanProposalScenarioInsightSections')}
      FormProps={{
        layout: InsightSection,
        LayoutProps: {
          hideErrorList: true,
          onSubmit,
        },
        readonly: true, // needed to hide action buttons
      }}
      padding={'none'}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

InsightForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default InsightForm;
